import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "home",
  id: "homePage",
  style: {
    "min-width": "1560px"
  }
};
const _hoisted_2 = {
  key: 0,
  class: "hometitle gloria-font"
};
const _hoisted_3 = {
  key: 1,
  class: "lowCode"
};
const _hoisted_4 = {
  key: 2,
  class: "richText"
};
const _hoisted_5 = {
  key: 3,
  class: "fit-up-item"
};
const _hoisted_6 = {
  key: 4,
  class: "fit-up-item"
};
const _hoisted_7 = {
  key: 5,
  class: "fit-up-item"
};
const _hoisted_8 = {
  key: 6,
  class: "fit-up-item"
};
const _hoisted_9 = {
  key: 7,
  class: "fit-up-item"
};
const _hoisted_10 = {
  class: "tabList"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  key: 0,
  src: "https://www.mimodental.com/assets/imgData/img/Zone/Polygon.png",
  alt: "",
  class: "Polygon"
};
const _hoisted_14 = {
  key: 0,
  class: "hometitle gloria-font"
};
const _hoisted_15 = {
  key: 1
};
const _hoisted_16 = {
  key: 2,
  class: "googleMaps"
};
const _hoisted_17 = {
  key: 3,
  class: "accordion"
};
const _hoisted_18 = {
  key: 4,
  class: "lowCode"
};
const _hoisted_19 = {
  key: 1,
  class: "ingList"
};
const _hoisted_20 = {
  key: 0,
  style: {
    "margin-bottom": "50px",
    "font-size": "42px"
  }
};
const _hoisted_21 = {
  key: 1,
  style: {
    "margin-bottom": "50px",
    "font-size": "42px"
  }
};
const _hoisted_22 = {
  key: 2
};
const _hoisted_23 = {
  key: 3,
  style: {
    "font-size": "42px"
  }
};
const _hoisted_24 = {
  key: 4,
  style: {
    "margin": "20px 0 50px 0"
  }
};
const _hoisted_25 = {
  key: 5,
  style: {
    "margin": "20px 0 50px 0"
  }
};
const _hoisted_26 = {
  style: {
    "display": "flex",
    "width": "80%",
    "justify-content": "space-between"
  }
};
const _hoisted_27 = ["onMouseover"];
const _hoisted_28 = ["src"];
const _hoisted_29 = ["src"];
const _hoisted_30 = {
  key: 0,
  style: {
    "font-size": "16pt",
    "padding-top": "30px",
    "zoom": "72%"
  }
};
const _hoisted_31 = {
  key: 5,
  class: "subscription"
};
const _hoisted_32 = {
  key: 6,
  class: "richText"
};
const _hoisted_33 = {
  key: 7,
  class: "fit-up-item"
};
const _hoisted_34 = {
  key: 8,
  class: "fit-up-item"
};
const _hoisted_35 = {
  key: 9,
  class: "fit-up-item"
};
const _hoisted_36 = {
  key: 10
};
const _hoisted_37 = {
  key: 11,
  class: "fit-up-item"
};
const _hoisted_38 = {
  key: 12,
  class: "goods-list fit-up-item"
};
const _hoisted_39 = {
  key: 13,
  class: "fit-up-item"
};
const _hoisted_40 = {
  key: 14,
  class: "fit-up-item"
};
const _hoisted_41 = {
  class: "ingList",
  style: {
    "margin": "0 0 80px 0"
  }
};
const _hoisted_42 = {
  key: 1,
  class: "types"
};
const _hoisted_43 = {
  class: "xiufu_tab"
};
const _hoisted_44 = ["onClick"];
const _hoisted_45 = {
  class: "img"
};
const _hoisted_46 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mimo_replace = _resolveComponent("mimo_replace");
  const _component_lowCode = _resolveComponent("lowCode");
  const _component_richText = _resolveComponent("richText");
  const _component_imgSwipers = _resolveComponent("imgSwipers");
  const _component_images = _resolveComponent("images");
  const _component_videos = _resolveComponent("videos");
  const _component_texts = _resolveComponent("texts");
  const _component_hotMap = _resolveComponent("hotMap");
  const _component_imageText = _resolveComponent("imageText");
  const _component_googleMaps = _resolveComponent("googleMaps");
  const _component_accordion = _resolveComponent("accordion");
  const _component_subscription = _resolveComponent("subscription");
  const _component_goodsScroll = _resolveComponent("goodsScroll");
  const _component_navigation = _resolveComponent("navigation");
  const _component_goodsGrid = _resolveComponent("goodsGrid");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.get_data, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "assembly"
    }, [item.base.title ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString(item.base.title), 1)])) : _createCommentVNode("", true), item.name === 'lowCode' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [item.data === '<mimo-replace>' ? (_openBlock(), _createBlock(_component_mimo_replace, {
      key: 0
    })) : (_openBlock(), _createBlock(_component_lowCode, {
      key: 1,
      data: item
    }, null, 8, ["data"]))])) : _createCommentVNode("", true), item.name === 'richText' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_richText, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'slider' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_imgSwipers, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'images' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_images, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'video' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_videos, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'text' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_texts, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'hotmap' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_hotMap, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true)]);
  }), 128)), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tabList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "tabItem",
      key: index,
      style: _normalizeStyle('background:' + ($setup.SelectedTab == index ? '#12A4BE;' : '#fff;') + 'color:' + ($setup.SelectedTab == index ? '#fff;' : '#000;')),
      onClick: $event => $setup.tabClick(index, item.key)
    }, [_createElementVNode("img", {
      src: 'https://www.mimodental.com/assets/imgData/img/Zone/' + item.img + '.png',
      class: "icon"
    }, null, 8, _hoisted_12), _createElementVNode("span", null, _toDisplayString(item.name), 1), $setup.SelectedTab == index ? (_openBlock(), _createElementBlock("img", _hoisted_13)) : _createCommentVNode("", true)], 12, _hoisted_11);
  }), 128))]), $setup.tabDatastate ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($setup.TabData, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "assembly"
    }, [item.base.title ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("span", null, _toDisplayString(item.base.title), 1)])) : _createCommentVNode("", true), item.name === 'imageText' ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_imageText, {
      data: item,
      imageTextIndex: index
    }, null, 8, ["data", "imageTextIndex"])])) : _createCommentVNode("", true), item.name === 'googleMaps' ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_googleMaps, {
      gMaps: item
    }, null, 8, ["gMaps"])])) : _createCommentVNode("", true), item.name === 'accordion' ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_accordion, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'lowCode' ? (_openBlock(), _createElementBlock("div", _hoisted_18, [item.data === '<mimo-replace>' ? (_openBlock(), _createBlock(_component_mimo_replace, {
      key: 0
    })) : _createCommentVNode("", true), item.data === '<imgList>' ? (_openBlock(), _createElementBlock("div", _hoisted_19, [$setup.tabList[$setup.SelectedTab].img == 'correct' ? (_openBlock(), _createElementBlock("h1", _hoisted_20, "矫治类型")) : _createCommentVNode("", true), $setup.tabList[$setup.SelectedTab].img == 'plant' ? (_openBlock(), _createElementBlock("h1", _hoisted_21, "种植类型")) : _createCommentVNode("", true), $setup.tabList[$setup.SelectedTab].img == 'treatment' ? (_openBlock(), _createElementBlock("h1", _hoisted_22, "优化牙周 巩固松牙")) : _createCommentVNode("", true), $setup.tabList[$setup.SelectedTab].img == 'children' ? (_openBlock(), _createElementBlock("h1", _hoisted_23, "儿牙综合")) : _createCommentVNode("", true), $setup.tabList[$setup.SelectedTab].img == 'children' ? (_openBlock(), _createElementBlock("span", _hoisted_24, "科学防蛀，呵护宝宝咀嚼力，助力快乐成长")) : _createCommentVNode("", true), $setup.tabList[$setup.SelectedTab].img == 'treatment' ? (_openBlock(), _createElementBlock("span", _hoisted_25, "牙周病分型诊疗更科学")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.img_list[$setup.tabList[$setup.SelectedTab].img], (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        style: _normalizeStyle([{
          "position": "relative",
          "box-sizing": "border-box"
        }, 'padding-top:' + (item.is_top ? '50px;' : '0px;') + 'width:' + item.width]),
        key: index,
        onMouseover: $event => $setup.onMouseOver(index),
        onMouseout: _cache[0] || (_cache[0] = (...args) => $setup.onMoouseOut && $setup.onMoouseOut(...args))
      }, [$setup.touch != index ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: 'https://www.mimodental.com/assets/imgData/img/Zone/tab_img/' + item.img + 's.png',
        style: {
          "width": "100%"
        }
      }, null, 8, _hoisted_28)) : _createCommentVNode("", true), $setup.touch == index ? (_openBlock(), _createElementBlock("img", {
        key: 1,
        src: 'https://www.mimodental.com/assets/imgData/img/Zone/tab_img/' + item.img + '.png',
        style: {
          "width": "100%"
        }
      }, null, 8, _hoisted_29)) : _createCommentVNode("", true)], 44, _hoisted_27);
    }), 128))]), _createElementVNode("div", null, [$setup.tabList[$setup.SelectedTab].img == 'correct' ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_cache[4] || (_cache[4] = _createTextVNode(" 想要了解更多，点击", -1)), _createElementVNode("span", {
      style: {
        "color": "#18A2C0",
        "cursor": "pointer",
        "font-size": "16pt",
        "text-decoration": "underline"
      },
      onClick: _cache[1] || (_cache[1] = (...args) => $setup.show && $setup.show(...args))
    }, "添加客服")])) : (_openBlock(), _createElementBlock("div", {
      key: 1,
      style: {
        "margin-top": "100px"
      },
      class: "my-scheme-btn",
      onClick: _cache[2] || (_cache[2] = (...args) => $setup.show && $setup.show(...args))
    }, _cache[5] || (_cache[5] = [_createTextVNode(" 获取我的专属方案", -1), _createElementVNode("span", {
      style: {
        "margin-left": "10px"
      }
    }, ">", -1)])))])])) : (_openBlock(), _createBlock(_component_lowCode, {
      key: 2,
      data: item
    }, null, 8, ["data"]))])) : _createCommentVNode("", true), item.name === 'subscription' ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createVNode(_component_subscription, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'richText' ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createVNode(_component_richText, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'slider' ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createVNode(_component_imgSwipers, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'images' ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_createVNode(_component_images, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'video' ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_createVNode(_component_videos, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'goodsScroll' ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createVNode(_component_goodsScroll, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'navigation' ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createVNode(_component_navigation, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'goodsGrid' ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_createVNode(_component_goodsGrid, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'text' ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createVNode(_component_texts, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'hotmap' ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_createVNode(_component_hotMap, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true)]);
  }), 128)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_41, [$setup.tabList[$setup.SelectedTab].img == 'correct' || $setup.tabList[$setup.SelectedTab].img == 'cosmetology' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "my-scheme-btn",
    style: {},
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.show && $setup.show(...args))
  }, _cache[6] || (_cache[6] = [_createTextVNode(" 获取我的专属方案", -1), _createElementVNode("span", {
    style: {
      "margin-left": "10px"
    }
  }, ">", -1)]))) : _createCommentVNode("", true)]), $setup.tabList[$setup.SelectedTab].img == 'repair' ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_cache[7] || (_cache[7] = _createElementVNode("h1", null, "修复类型", -1)), _createElementVNode("div", _hoisted_43, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.xiufuList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      onClick: $event => $setup.xiufuList_index = index,
      style: _normalizeStyle('color:' + ($setup.xiufuList_index == index ? '#16A7B9;' : '#7E7E7E;') + 'border-bottom: 5px solid' + ($setup.xiufuList_index == index ? '#16A7B9' : 'none;'))
    }, _toDisplayString(item), 13, _hoisted_44);
  }), 128))]), _createElementVNode("div", _hoisted_45, [_createElementVNode("img", {
    src: 'https://www.mimodental.com/assets/imgData/img/Zone/' + ($setup.xiufuList_index + 1) + '.jpeg',
    alt: ""
  }, null, 8, _hoisted_46)])])) : _createCommentVNode("", true)]);
}